import actionTypes from './GRSMMERF01ActionType';

/**
 * 応募者詳細
 */
const initialState = {
    isFetching: false,
    candidateData: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 応募者情報を登録するReducer
 * @param {*} state
 * @param {*} action
 */
export const saveCandidate = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_CANDIDATE_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                candidateData: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.SAVE_CANDIDATE_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                candidateData: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.SAVE_CANDIDATE_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                candidateData: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.SAVE_CANDIDATE_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                candidateData: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
